import React from "react";
import { Avatar, ExternalLink } from "./Ui";

const RESOLUTION_LABEL = {
  sf_contact: "Matched to an existing Salesforce contact",
  scraped: "Looked up on LinkedIn",
  unresolved: "Could not be resolved",
};
const SOURCE_LABEL = {
  salesforce: "Salesforce",
  cache: "LinkedIn (cached)",
  apify: "LinkedIn (live lookup)",
};

// A LinkedIn profile the message pointed at (context.linkedInProfiles[i])
export default function LinkedInProfileCard({ profile }) {
  const p = profile || {};
  const failed = p.resolution === "unresolved" || !!p.error;
  const line = [p.title && p.company ? `${p.title} at ${p.company}` : p.title || p.company, p.location].filter(Boolean).join(" · ");
  return (
    <div className={`ob-li-card ${failed ? "is-failed" : ""}`}>
      {p.pictureUrl ? <img className="ob-li-card__pic" src={p.pictureUrl} alt="" /> : <Avatar name={p.name} email={p.email} size={40} />}
      <div className="ob-li-card__main">
        <div className="ob-li-card__name">
          <span>{p.name || p.slug || "LinkedIn profile"}</span>
          <a className="ob-li-card__link" href={p.url} target="_blank" rel="noopener noreferrer" title={p.url}>
            in
          </a>
          {p.internal && <span className="ob-pill ob-pill--sm ob-pill--slate">Landmark</span>}
        </div>
        {p.headline && <div className="ob-li-card__headline">{p.headline}</div>}
        {line && <div className="ob-li-card__sub">{line}</div>}
        <div className="ob-li-card__sub">
          {p.email ? <span>{p.email}</span> : <span className="ob-muted">no email on the profile</span>}
        </div>
        <div className="ob-li-card__links">
          {p.contactUrl ? <ExternalLink href={p.contactUrl}>Contact: {p.contactName || p.name}</ExternalLink> : <span className="ob-pill ob-pill--sm ob-pill--success">new contact</span>}
          {p.accountUrl ? (
            <ExternalLink href={p.accountUrl}>
              Account: {p.accountName}
              {p.accountMatchedBy ? ` (${p.accountMatchedBy})` : ""}
            </ExternalLink>
          ) : (
            <span className="ob-muted">no account matched</span>
          )}
        </div>
        <div className="ob-li-card__foot">
          {failed ? (
            <span className="ob-inline-error">{p.error || RESOLUTION_LABEL.unresolved}</span>
          ) : (
            <>
              {RESOLUTION_LABEL[p.resolution] || p.resolution}
              {p.source ? ` · ${SOURCE_LABEL[p.source] || p.source}` : ""}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
